export default __webpack_public_path__ + "static/media/dashboard-info.60477a0c.pdf";